var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_vm._v("\n  排队查询\n")])}
var staticRenderFns = []

export { render, staticRenderFns }